import React from 'react';
import { DropdownProps } from 'semantic-ui-react';

const Playlist: React.FC<{
  playlist: PlaylistVideo[];
  showPlaylist: boolean;
  togglePlaylist: () => void;
  removeFromPlaylist: (url: string) => void;
  setMedia: (e: any, data: DropdownProps) => void;
}> = ({
  playlist,
  showPlaylist,
  removeFromPlaylist,
  setMedia,
  togglePlaylist,
}) => {
  if (!showPlaylist) return null;
  return (
    <div className="fixed inset-0 size-full z-[9999] grid place-items-center bg-black/80">
      <div className="relative overflow-hidden p-[1px] after:content-[''] after:absolute after:inset-0 after:rounded-xl after:p-[5px] after:pointer-events-none after:z-0 gradient-pink-border max-w-xl w-full">
        <div className="relative z-[1] overflow-hidden bg-[#040404] p-3 rounded-xl w-full">
          <div className="flex items-center justify-between w-full mb-3">
            <h4 className="text-2xl text-semibold text-gradient-blue inline-block">
              Watchlist
            </h4>
            <button className="text-white text-3xl" onClick={togglePlaylist}>
              <i className="ri-close-circle-line"></i>
            </button>
          </div>
          <div className="flex flex-col gap-3 max-h-[500px] overflow-auto">
            {playlist.map((item) => {
              return (
                <button
                  key={item.url}
                  className="flex gap-3 items-center text-start hover:opacity-70"
                  onClick={() => {
                    setMedia(null, { value: item.url });
                    togglePlaylist();
                  }}
                >
                  <img
                    className="w-32 h-24 object-cover rounded-xl"
                    src={item.img}
                    alt={`video-${item.url}`}
                  />
                  <p className="text-[16px] text-white line-clamp-3">
                    {item.name ? item.name : item.url}
                  </p>
                  <button
                    className="gradient-btn text-black flex-shrink-0 flex items-center gap-1 rounded-lg justify-center text-2xl duration-200  hover:opacity-70 size-12"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      removeFromPlaylist(item.url);
                      if (playlist.length === 1) {
                        togglePlaylist();
                      }
                    }}
                  >
                    <i className="ri-close-fill"></i>
                  </button>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Playlist;
